import { Box } from '@mui/material';

export const ContentBox = ({ children, sx = {}, ...props }) => {
  return (
    <Box
      id="content-box"
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        height: '100%',
        gap: 2,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
